module.exports = __webpack_public_path__ + "img/dog_clock.7000d289.png";